/* eslint-disable react/prop-types */
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

/** Generic 12-month {month, amount} trend line — reused for offerings/tithes/welfare/harvest. */
export default function MonthlyTrendChart({ data, color, emptyLabel }) {
  const hasData = data && data.length > 0 && data.some((d) => Number(d.amount) > 0);

  if (!hasData) {
    return (
      <Box sx={{ py: 4, textAlign: "center" }}>
        <Typography variant="body2" color="text.secondary">
          {emptyLabel || "No payments recorded yet."}
        </Typography>
      </Box>
    );
  }

  const chartData = {
    labels: data.map((d) => d.month),
    datasets: [
      {
        label: "Amount",
        data: data.map((d) => Number(d.amount)),
        borderColor: color,
        backgroundColor: `${color}33`,
        pointRadius: 0,
        pointHoverRadius: 4,
        borderWidth: 2,
        tension: 0.35,
        fill: true,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          title: (items) => data[items[0].dataIndex].month,
          label: (item) =>
            `GHS ${Number(item.raw).toLocaleString(undefined, { maximumFractionDigits: 2 })}`,
        },
      },
    },
    scales: {
      x: { grid: { display: false } },
      y: { beginAtZero: true },
    },
  };

  return (
    <Box sx={{ height: { xs: 220, md: 250 } }}>
      <Line data={chartData} options={options} />
    </Box>
  );
}
